import { createContext, useContext } from "react";

const MomentNewContext = createContext(false);

export const MomentNewProvider = MomentNewContext.Provider;

export const useIsNewMoment = (): boolean => useContext(MomentNewContext);
